export class AdditionalField {
  constructor(public title: string, public name: string) {}
}
